import { useState, useCallback } from "react";
import { calendarService } from "../services/calendarService";
import managementService from "../services/managementService";

/**
 * slots = [
 *   {
 *     id,             // SLOT ID
 *     slot_date,
 *     start_time,
 *     end_time,
 *     is_all_day,
 *     slot_status,
 *     event: { id, name, event_type },
 *     participants: [],
 *     instructors: [],
 *   }
 * ]
 */
export function useCalendarSlots() {
  const [slots, setSlots] = useState([]);
  const [isSyncing, setIsSyncing] = useState(false);

  /* ============================
     FETCH SERVER
     ============================ */
  const refetchSlots = useCallback(async (from, to) => {
    setIsSyncing(true);
    try {
      const data = await calendarService.getCalendarView(from, to);
      setSlots(data);
    } finally {
      setIsSyncing(false);
    }
  }, []);

  /* ============================
     DELETE SLOT
     ============================ */
  const handleDeleteEventSlot = useCallback(async (slotId) => {
    setIsSyncing(true);
    try {
      await managementService.deleteSlot(slotId);
    } finally {
      setIsSyncing(false);
    }
  }, []);

  return {
    slots,
    isSyncing,
    refetchSlots,
    handleDeleteEventSlot,
  };
}
